<template>
  <v-row justify="center">
    <v-dialog
      origin="top center"
      v-model="dialogStatus"
      persistent
      content-class="serial-number-dialog"
      :max-width="dialogWidth"
    >
      <v-card>
        <v-card-title
          class="headline dialog-custom-header white-background custom-border-bottom custom-header-blue-text"
        >
          <template v-if="lodash.isEmpty(serialNumberDetail) === false">
            Update Serial Number
          </template>
          <template v-else-if="!serialized"> Add Inventory </template>
          <template v-else> Add Serial Number</template>

          - &nbsp;<span class="orange--text">{{ productInfo.barcode }}</span>
        </v-card-title>
        <v-card-text class="p-8 font-size-16">
          <perfect-scrollbar
            :options="{ suppressScrollX: true }"
            class="scroll"
            style="max-height: calc(100vh - 280px); position: relative"
          >
            <v-form
              ref="serialNumberForm"
              v-model.trim="formValid"
              lazy-validation
              v-on:submit.stop.prevent="update_or_create"
            >
              <v-container fluid>
                <v-row>
                  <!-- Product Information Display -->
                  <v-col
                    md="12"
                    class="py-0 mb-4"
                    v-if="productInfo && productInfo.barcode"
                  >
                    <v-layout
                      class="nmt-1 bg-quo pb-3 custom-border-bottom"
                      style="margin-bottom: 2rem"
                    >
                      <v-flex md2 class="mr-2">
                        <table width="100%">
                          <tr>
                            <td class="py-1">
                              <v-avatar size="80">
                                <ImageNew
                                  :images="productInfo.product_images"
                                  :parent="productInfo.id"
                                  type="service"
                                  width="80"
                                  height="80"
                                  :isPageLoading="pageLoading"
                                >
                                </ImageNew>
                              </v-avatar>
                            </td>
                          </tr>
                        </table>
                      </v-flex>
                      <v-flex md4 class="mr-2">
                        <table width="100%" class="mt-4">
                          <tr v-if="productInfo.barcode">
                            <td class="py-0">
                              <label
                                ><span class="font-weight-600">ID: </span>
                                <span>{{ productInfo.barcode }}</span></label
                              >
                            </td>
                          </tr>
                          <tr v-if="productInfo.name">
                            <td class="py-0">
                              <label
                                ><span class="font-weight-600">Name: </span>
                                <span>{{ productInfo.name }}</span></label
                              >
                            </td>
                          </tr>
                        </table>
                      </v-flex>
                      <v-flex md6 class="mr-2">
                        <table width="100%" class="mt-4">
                          <tr>
                            <td class="py-0" v-if="productInfo.brand">
                              <label
                                ><span class="font-weight-600">Model: </span>
                                <span>{{ productInfo.brand }}</span></label
                              >
                            </td>
                            <td class="py-0" v-else>
                              <em class="text-muted ml-2">no model</em>
                            </td>
                          </tr>
                          <tr>
                            <td class="py-0" v-if="productInfo.category">
                              <label
                                ><span class="font-weight-600">Category: </span>
                                <span>{{ productInfo.category }}</span></label
                              >
                            </td>
                            <td class="py-0" v-else>
                              <em class="text-muted ml-2">no category</em>
                            </td>
                          </tr>
                        </table>
                      </v-flex>
                    </v-layout>
                  </v-col>

                  <!-- <v-row>
                                        <v-col xl="12" lg="12" md="12" class="py-0">

                                        <label class="font-weight-600 my-1">Quantity</label>
                                        <v-text-field dense filled color="cyan" placeholder="Quantity"
                                            solo flat v-model.trim="serialNumberOption.initial_stock"
                                            :disabled="pageLoading" :maxLength="5"></v-text-field>
                                        </v-col>  

                                     </v-row> -->

                  <!-- Serial Number Configuration -->
                  <v-col md="12" class="py-0 mb-4">
                    <v-card
                      flat
                      class="custom-grey-border remove-border-radius"
                    >
                      <v-card-title
                        class="headline grey lighten-4"
                        v-if="false"
                      >
                        <h3
                          class="font-weight-700 custom-headline color-custom-blue"
                        >
                          Serial no.
                        </h3>
                      </v-card-title>
                      <v-card-text class="p-6 font-size-16">
                        <!-- Quantity Display -->

                        <v-row>
                          <v-col xl="12" lg="12" md="12" class="py-0">
                            <label class="font-weight-600 my-1">Quantity</label>
                            <v-text-field
                              dense
                              filled
                              color="cyan"
                              placeholder="Quantity"
                              solo
                              flat
                              v-model.trim="serialNumberOption.initial_stock"
                              :disabled="pageLoading"
                              :maxLength="5"
                            ></v-text-field>
                          </v-col>
                          <v-col xl="2" lg="2" md="3" class="py-0">
                            <label class="font-weight-700 font-size-16 pr-6">
                              <span>Add Serial No.</span>
                            </label>
                          </v-col>
                          <v-col xl="10" lg="10" md="9" class="py-0">
                            <div>
                              <label class="font-weight-700 font-size-16">
                                <span class="pr-5">Qty:</span>
                                <span class="text-h5 font-weight-bold">
                                  {{ serialNumberOption.initial_stock || 0 }} /
                                  {{
                                    serialNumberOption.searial_numbers
                                      ?.length || 0
                                  }}
                                </span>
                              </label>
                            </div>
                          </v-col>
                        </v-row>

                        <!-- Auto Generated Radio Group -->
                        <v-row v-if="serialized">
                          <v-col xl="2" lg="2" md="3" class="py-0">
                            <label class="font-weight-700 font-size-16">
                              <span>Auto Generated?</span>
                            </label>
                          </v-col>
                          <v-col xl="2" lg="2" md="3" class="py-0">
                            <v-radio-group
                              v-model="serialNumberOption.isAutoGenerated"
                              row
                              :disabled="pageLoading"
                            >
                              <v-radio
                                on-icon="mdi-checkbox-marked"
                                off-icon="mdi-checkbox-blank-outline"
                                label="Yes"
                                @change="clearSerialNumbers"
                                :value="1"
                              ></v-radio>
                              <v-radio
                                on-icon="mdi-checkbox-marked"
                                off-icon="mdi-checkbox-blank-outline"
                                label="No"
                                @change="clearSerialNumbers"
                                :value="0"
                                class="mr-0"
                              ></v-radio>
                            </v-radio-group>
                          </v-col>
                          <v-col
                            xl="8"
                            lg="8"
                            md="6"
                            class="py-0 pl-4 my-auto"
                            v-if="
                              false && serialNumberOption.isAutoGenerated == 0
                            "
                          >
                            <label class="font-weight-700 font-size-16 pr-10">
                              <span>Upload your file:</span>
                            </label>
                            <v-btn
                              outlined
                              class="custom-bold-button text-white"
                              color="cyan"
                              @click="importDialog = true"
                              :disabled="pageLoading"
                            >
                              Import
                            </v-btn>
                          </v-col>

                          <v-col
                            xl="1"
                            lg="1"
                            md="1"
                            class="py-0 d-flex align-center justify-center"
                            v-if="serialNumberOption.isAutoGenerated == 0"
                          >
                          </v-col>

                          <v-col
                            xl="8"
                            lg="8"
                            md="8"
                            class="py-0 pl-3 my-auto"
                            v-if="serialNumberOption.isAutoGenerated == 0"
                          >
                            <div class="d-flex flex-column align-start">
                              <label class="font-weight-700 font-size-16 mb-2"
                                >Add Manually:</label
                              >
                              <v-btn
                                outlined
                                class="mb-5 custom-bold-button text-white"
                                color="cyan"
                                @click="addingFieldsManually"
                                >Manual</v-btn
                              >
                            </div>
                          </v-col>

                          <span
                            v-if="
                              serialNumberOption.isAutoGenerated == 0 &&
                              showMessage
                            "
                            class="font-weight-bold font-size-16 text-grey-darken-1 m-5"
                            style="color: red !important"
                            >Note: Match the count to serial boxes as per
                            Quantity.</span
                          >
                        </v-row>

                        <!-- Auto Generated Configuration -->
                        <v-row
                          v-if="
                            serialNumberOption.isAutoGenerated != 0 &&
                            serialized
                          "
                        >
                          <v-col cols="12" class="pb-0">
                            <label
                              class="pr-4 font-weight-bold font-size-16 width-100"
                            >
                              Serial no.
                            </label>
                          </v-col>
                          <v-col xl="4" lg="4" md="6" class="py-0">
                            <div class="d-flex align-center">
                              <label
                                class="font-weight-700 font-size-16 width-100"
                              >
                                Prefix
                              </label>
                              <label
                                class="font-weight-700 font-size-16 width-100"
                              >
                                No.
                              </label>
                            </div>
                          </v-col>
                          <v-col xl="8" lg="8" md="8" class="py-0">
                            <label
                              class="font-weight-700 font-size-16 width-100"
                            >
                              Preview
                            </label>
                          </v-col>
                          <v-col xl="4" lg="4" md="6" class="py-0">
                            <div class="d-flex">
                              <v-text-field
                                dense
                                filled
                                placeholder="Prefix"
                                solo
                                flat
                                color="cyan"
                                class="pr-2 width-100"
                                :disabled="pageLoading"
                                :rules="[
                                  validateRules.minLength(
                                    serialNumberOption.serial_prefix,
                                    'Serial Prefix',
                                    1
                                  ),
                                  validateRules.maxLength(
                                    serialNumberOption.serial_prefix,
                                    'Serial Prefix',
                                    100
                                  ),
                                ]"
                                v-model.trim="serialNumberOption.serial_prefix"
                              >
                              </v-text-field>
                              <v-text-field
                                type="number"
                                dense
                                filled
                                placeholder="Prefix no."
                                solo
                                flat
                                color="cyan"
                                :disabled="pageLoading"
                                class="pr-2 width-100"
                                v-on:keypress="isNumber($event)"
                                v-model.trim="
                                  serialNumberOption.serial_prefix_no
                                "
                              >
                              </v-text-field>
                            </div>
                          </v-col>
                          <v-col xl="8" lg="8" md="6" class="py-0">
                            <div class="d-flex align-center">
                              <div
                                class="font-weight-700 font-size-16 pr-10 text-uppercase"
                              >
                                {{ serialNumberOption?.serial_prefix }}-{{
                                  serialNumberOption?.serial_prefix_no
                                }}
                              </div>
                              <v-btn
                                depressed
                                class="custom-bold-button text-white"
                                color="cyan"
                                :disabled="
                                  !serialNumberOption?.serial_prefix_no ||
                                  pageLoading
                                "
                                @click="generatePrefixes"
                              >
                                Generate
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>

                        <v-divider class="my-0"></v-divider>

                        <!-- Serial Numbers List -->
                        <v-row
                          v-if="serialNumberOption?.searial_numbers?.length > 0"
                          style="margin-bottom: 25px !important"
                        >
                          <v-col
                            lg="3"
                            md="3"
                            v-for="(
                              row, rowindex
                            ) in serialNumberOption.searial_numbers"
                            :key="rowindex"
                          >
                            <div class="d-flex">
                              <input
                                @input="checkCodes(row, rowindex)"
                                v-model="row.text"
                                class="mt-0 mr-0 w-100"
                                :placeholder="
                                  'Enter serial no ' + (rowindex + 1)
                                "
                                style="
                                  padding: 4px !important;
                                  border: 1px solid darkgrey;
                                "
                                :disabled="pageLoading"
                              />
                              <v-icon
                                v-if="row.editable"
                                left
                                :disabled="pageLoading"
                                color="red"
                                @click="deleteNumber(rowindex)"
                              >
                                mdi-close
                              </v-icon>
                            </div>
                            <div v-if="row?.error" class="red--text">
                              Serial Number Already Exists
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Additional Fields -->
                  <v-col md="6" class="py-0">
                    <label class="font-weight-600 my-1">Purchase Date</label>
                    <DatePicker
                      :defaultDate="serialNumberOption.purchase_date"
                      solo
                      :pageLoading="pageLoading"
                      :placeholder="'Purchase Date'"
                      v-model="serialNumberOption.purchase_date"
                    ></DatePicker>
                  </v-col>
                  <v-col md="6" class="py-0">
                    <label class="font-weight-600 my-1">Purchase Order </label>
                    <v-text-field
                      dense
                      filled
                      color="cyan"
                      placeholder="Purchase Order "
                      solo
                      flat
                      v-model.trim="serialNumberOption.inbound_doc"
                      :disabled="pageLoading"
                    ></v-text-field>
                  </v-col>

                  <v-col md="12" class="py-0">
                    <label class="font-weight-600 my-1">Notes</label>
                    <v-textarea
                      class="required-field"
                      dense
                      filled
                      label="Notes"
                      solo
                      flat
                      row-height="20"
                      auto-grow
                      :disabled="pageLoading"
                      color="cyan"
                      v-model.trim="serialNumberOption.notes"
                      :rules="[
                        validateRules.minLength(
                          serialNumberOption.notes,
                          'Notes',
                          1
                        ),
                        validateRules.maxLength(
                          serialNumberOption.notes,
                          'Notes',
                          1024
                        ),
                      ]"
                      v-on:keypress="(e) => manageLimitdescr(e)"
                      v-on:paste="(e) => onPaste(e)"
                    ></v-textarea>
                    <v-col md="12" class="text-right"
                      >{{
                        serialNumberOption.notes
                          ? serialNumberOption.notes?.length
                          : 0
                      }}/200
                    </v-col>
                  </v-col>

                  <v-col md="6" class="py-0">
                    <label class="font-weight-600 my-1">Inbound Date</label>
                    <DatePicker
                      :defaultDate="serialNumberOption.inbound_date"
                      solo
                      :pageLoading="pageLoading"
                      :placeholder="'Inbound Date'"
                      v-model="serialNumberOption.inbound_date"
                    ></DatePicker>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </perfect-scrollbar>
        </v-card-text>
        <v-divider class="my-0"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="serial-number-manage-action">
            <v-btn
              depressed
              :loading="pageLoading"
              :disabled="pageLoading"
              v-on:click="$emit('close:dialog')"
              class="mx-2 custom-grey-border custom-bold-button"
            >
              Cancel
            </v-btn>
            <v-btn
              depressed
              :disabled="!formValid || pageLoading"
              :loading="pageLoading"
              v-on:click="update_or_create"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
            >
              Save
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style scoped>
.v-dialog__content {
  align-items: start;
}

.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  max-height: 18px;
  padding: 0;
}
</style>

<script>
import moment from "moment";
import DatePicker from "@/view/pages/partials/Datepicker.vue";
import {
  POST,
  GET,
  PUT,
  CLEAR_ERROR,
} from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { cloneDeep } from "lodash";
import ImageNew from "@/view/pages/partials/Detail/ImageNew";
import { v4 as uuidv4 } from "uuid";
import { ErrorEventBus } from "@/core/lib/message.lib";

export default {
  name: "create-or-update-serial-number",
  mixins: [ValidationMixin, CommonMixin],
  props: {
    dialogStatus: {
      type: Boolean,
      default: false,
    },
    serialNumberDetail: {
      type: Object,
      default: () => {
        return new Object();
      },
    },
    productId: {
      type: Number,
      default: 0,
    },

    serialized: {
      type: Number,
      default: 0,
    },
  },
  components: {
    DatePicker,
    ImageNew,
  },
  watch: {
    "serialNumberOption.initial_stock"() {
      if (
        this.serialNumberOption.initial_stock ==
        this.serialNumberOption?.searial_numbers?.length
      ) {
        this.serialNumberOption.searial_numbers.forEach((item) => {
          item.editable = false;
        });
      } else if (
        this.serialNumberOption.initial_stock >
        this.serialNumberOption?.searial_numbers?.length
      ) {
        this.serialNumberOption.searial_numbers.forEach((item) => {
          item.editable = false;
        });
      } else if (
        this.serialNumberOption.initial_stock <
        this.serialNumberOption?.searial_numbers?.length
      ) {
        this.serialNumberOption.searial_numbers.forEach((item, index) => {
          if (index >= this.serialNumberOption.initial_stock) {
            item.editable = true;
          } else {
            item.editable = false;
          }
        });
      }
    },
    dialogStatus: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.getProductDetail();
          this.initializeData();
        }
      },
    },
  },
  data() {
    return {
      formValid: true,
      pageLoading: false,
      importDialog: false,
      activeRowIndex: null,
      serialNumberOption: {
        id: null,
        product_id: 0,
        initial_stock: 0,
        isAutoGenerated: 1,
        serial_prefix: null,
        serial_prefix_no: null,
        searial_numbers: [],
        purchase_date: moment().format("YYYY-MM-DD"),
        inbound_date: moment().format("YYYY-MM-DD"),
        inbound_doc: null,
        outbound_date: null,
        outbound_doc: null,
        notes: null,
      },
      productInfo: {},
    };
  },
  methods: {
    manageLimitdescr(e) {
      this.errorMessage = null;
      if (
        this.serialNumberOption.notes &&
        this.serialNumberOption.notes.length > 199
      ) {
        e.preventDefault();
      }
    },
    onPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.serialNumberOption.notes;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.serialNumberOption.notes = trimValue;
        e.preventDefault();
      }
    },
    clickOutside() {
      this.activeRowIndex = null;
    },
    getProductDetail() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "product/" + _this.productId,
        })
        .then(({ data }) => {
          _this.productInfo = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    initializeData() {
      if (this.productId > 0) {
        this.serialNumberOption.product_id = this.productId;
      }
      if (!this.lodash.isEmpty(this.serialNumberDetail)) {
        this.serialNumberOption = cloneDeep(this.serialNumberDetail);
      }
    },
    clearSerialNumbers() {
      this.serialNumberOption.searial_numbers = [];
      if (this.serialNumberOption.isAutoGenerated == 0) {
        this.serialNumberOption.serial_prefix = null;
        this.serialNumberOption.serial_prefix_no = null;
      }
    },
    generatePrefixes() {
      if (!this.serialNumberOption.serial_prefix_no) {
        return;
      }

      const prefix = this.serialNumberOption.serial_prefix || "";
      const startNumber = parseInt(this.serialNumberOption.serial_prefix_no);
      const quantity = this.serialNumberOption.initial_stock || 1;

      this.serialNumberOption.searial_numbers = [];

      for (let i = 0; i < quantity; i++) {
        const serialNumber = `${prefix}-${startNumber + i}`;
        this.serialNumberOption.searial_numbers.push({
          text: serialNumber,
          editable: true,
          error: false,
        });
      }
    },
    checkCodes(row, rowindex) {
      // Check for duplicate serial numbers
      const duplicates = this.serialNumberOption.searial_numbers.filter(
        (item, index) => index !== rowindex && item.text === row.text
      );

      if (duplicates.length > 0) {
        row.error = true;
      } else {
        row.error = false;
      }
    },
    deleteNumber(index) {
      this.serialNumberOption.searial_numbers.splice(index, 1);
    },
    isNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },

    addingFieldsManually() {
      if (this.serialNumberOption?.initial_stock) {
        this.serialNumberOption.searial_numbers = [];
        for (let i = 1; i <= this.serialNumberOption.initial_stock; i++) {
          let newCode = {
            uuid: uuidv4(),
            text: "",
            editable: false,
            error: false,
            isManual: 1,
          };

          this.serialNumberOption.searial_numbers.push(newCode);
        }
        this.preNumbers = this.lodash.cloneDeep(
          this.serialNumberOption.searial_numbers
        );
      } else {
        ErrorEventBus.$emit(
          "update:error",
          "Please set the initial stock quantity first."
        );
      }
    },

    update_or_create() {
      const _this = this;
      if (!_this.$refs.serialNumberForm.validate()) {
        return false;
      }

      _this.$store.dispatch(CLEAR_ERROR, {});
      _this.pageLoading = true;

      let formData = new FormData();
      formData.append("product_id", _this.serialNumberOption.product_id);
      formData.append(
        "initial_stock",
        _this.serialNumberOption.initial_stock || 0
      );
      formData.append(
        "is_auto_generated",
        _this.serialNumberOption.isAutoGenerated
      );

      if (_this.serialNumberOption.serial_prefix) {
        formData.append(
          "serial_prefix",
          _this.serialNumberOption.serial_prefix
        );
      }
      if (_this.serialNumberOption.serial_prefix_no) {
        formData.append(
          "serial_prefix_no",
          _this.serialNumberOption.serial_prefix_no
        );
      }
      if (_this.serialNumberOption.purchase_date) {
        formData.append(
          "purchase_date",
          _this.serialNumberOption.purchase_date
        );
      }
      if (_this.serialNumberOption.inbound_date) {
        formData.append("inbound_date", _this.serialNumberOption.inbound_date);
      }
      if (_this.serialNumberOption.inbound_doc) {
        formData.append("inbound_doc", _this.serialNumberOption.inbound_doc);
      }
      if (_this.serialNumberOption.outbound_date) {
        formData.append(
          "outbound_date",
          _this.serialNumberOption.outbound_date
        );
      }
      if (_this.serialNumberOption.outbound_doc) {
        formData.append("outbound_doc", _this.serialNumberOption.outbound_doc);
      }
      if (_this.serialNumberOption.notes) {
        formData.append("notes", _this.serialNumberOption.notes);
      }

      // Add serial numbers
      if (
        _this.serialNumberOption.searial_numbers &&
        _this.serialNumberOption.searial_numbers.length > 0
      ) {
        formData.append(
          "searial_numbers",
          JSON.stringify(_this.serialNumberOption.searial_numbers)
        );
      }

      let requestTYPE = POST;
      let requestURL = `product/${this.productId}/create-serial-number`;

      if (_this.serialNumberOption.id) {
        requestTYPE = PUT;
        formData.append("id", _this.serialNumberOption.id);
      }

      _this.$store
        .dispatch(requestTYPE, {
          url: requestURL,
          data: formData,
        })
        .then(() => {
          _this.$emit("update:serial-numbers", true);
          _this.$emit("close:dialog");
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 60);
    },
    showMessage() {
      return (
        this.serialNumberOption.initial_stock !=
        this.serialNumberOption?.searial_numbers?.length
      );
    },
  },
  mounted() {
    this.getProductDetail();
  },
};
</script>
